<form [formGroup]="form" novalidate class="d-flex flex-column gap-3">
  <span class="fw-bold"
    >{{ 'admin.grid.clientSelected' | translate }} {{ prevModel.name }}</span
  >
  <div formArrayName="clientAssignments">
    <gstar-user-search (userSelect)="userSelect($event)" />
    @for (assignment of clientAssignments.controls; track $index) {
      <div class="ap-mb-spacing-4 d-flex">
        <ap-field [hidden]="true">
          <input appkit-field [formControlName]="$index" />
        </ap-field>
        <div class="me-auto">
          <div class="d-flex align-items-center">
            <ap-avatar
              diameter="40"
              borderWidth="0"
              [name]="assignment.value?.initials ?? ''"
              [disabled]="true"></ap-avatar>
            <span class="ap-ml-spacing-4">
              {{ assignment.value?.fullName ?? '' }}
            </span>
          </div>
        </div>
        <div>
          <button
            (click)="removeAssignment($index)"
            class="Appkit4-icon icon-delete-outline">
            &nbsp;
          </button>
        </div>
      </div>
    }
  </div>
</form>
